import React, {Component} from 'react';
import * as firebase from 'firebase';
import CurrentExpo from './current-expo';
import SampleExpo from './sample-expo';
import ArchivedExposList from './archived-expos-list';
import './expo-list.css';

/** @class ExpoSeries
  * A component for displaying a series
  * of virtual expos.
  * @prop {String} name - the name of the series
  * @prop {String} current - the ID of the current expo in the series
  * @prop {Object} archived - the IDs of archived expos
  */
export default class ExpoSeries extends Component {
  /** @constructor
    * Initializes a new ExpoSeries
    */
  constructor(props) {
    super(props);
    this.archiveExpo = this.archiveExpo.bind(this);
  }
  /** @function archive
    * Archives the selected show and generates a
    * clone to replace it as the "curent" show.
    * @param {String} expoID - the id of the expo to archive
    */
  archiveExpo(expoID) {
    // Step 1: Retrieve the expo to clone
    firebase.database().ref(`/expos/${expoID}`).once('value', snapshot => {
      var clone = snapshot.val();
      var archiveYear = new Date(clone.metadata.opens).getFullYear();
      // Step 2: Update the expo metadata
      var opens = new Date(clone.metadata.opens);
      opens = opens.setFullYear(opens.getFullYear() + 1);
      clone.metadata.opens = opens;
      var closes = new Date(clone.metadata.closes);
      closes = closes.setFullYear(closes.getFullYear() + 1);
      clone.metadata.closes = closes;
      // Step 3: Push the new expo to the database
      var cloneRef = firebase.database().ref('/expos').push(clone);
      // Step 4: Update the series and old expo
      var updates = {
        [`/series/${this.props.id}/current`]: cloneRef.key,
        [`/series/${this.props.id}/archived/${archiveYear}`]: expoID
      }
      firebase.database().ref().update(updates, (err)=>{
        console.error(err);
      });
    });
  }
  /** @function render
    * Renders the expo series.
    */
  render() {
    return (
      <div className="series">
        <h2>{this.props.name}</h2>
        <CurrentExpo expoID={this.props.current} archiveExpo={this.archiveExpo}/>
        <SampleExpo expoID={this.props.sample} />
        {this.props.archived ? <ArchivedExposList archived={this.props.archived}/> : ''}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/series-list/expo-series.js